import { SocketEvent } from '@/services/ws/core/event'
import { BE_LIMIT_TYPE } from '@/components/Limits/constants'

class PauseLimitsEvent extends SocketEvent {
  async handle(data, { store }) {
    const gamePause = data?.limits?.pause
    gamePause && store.commit('limits/set_limitsGamePause', data?.limits)

    const gameExceededLimits = data?.limits?.exceeded_limits?.find(el => el.type === BE_LIMIT_TYPE.GAME_SESSION)
    if (gameExceededLimits) {
      store.commit('limits/set_gameExceededLimits', gameExceededLimits)
    }
    else {
      if (store.getters['game/get_isShowLimitsExceededModal']) {
        await store.dispatch('game/fetch_game')
      }
    }
  }
}

export const pauseLimitsEvent = new PauseLimitsEvent()
